import * as React from "react";
const SearchIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" {...props}>
    <path
      {...props}
      d="M21 19v-1h-1v-1h-1v-1h-1v-1h-2v-1h1v-2h1V6h-1V4h-1V3h-1V2h-1V1h-2V0H6v1H4v1H3v1H2v1H1v2H0v6h1v2h1v1h1v1h1v1h2v1h6v-1h2v-1h1v2h1v1h1v1h1v1h1v1h2v-1h1v-2h-1Zm-10-5v1H7v-1H5v-1H4v-2H3V7h1V5h1V4h2V3h4v1h2v1h1v2h1v4h-1v2h-1v1h-2Z"
    />
  </svg>
);
export default SearchIcon;
